import axios from 'axios'
import csrfTokenHandler from './csrfTokenHandler'
import { API_URL } from '../utils/constants'

const getVenueUnavailableDates = async (venueUuid: string) => {
  await csrfTokenHandler()

  return axios.get(`${API_URL}/api/venues/unavailability/${venueUuid}`)
}
export default getVenueUnavailableDates
